import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import AddNewStaff from './AddNewStaff';
import EditStaff from './EditStaff';
import TransferWorkLoad from './TransferWorkLoad';
import StaffPrintPages from './StaffPrintPages';

const StaffSetupLazy = React.lazy(
	() => import(/* webpackChunkName : 'StaffSetup' */ './components/StaffSetup')
);

export default (store) => {
	return [
		{
			path: 'staff-setup/:campusId?',
			element: <AsyncLoading component={<StaffSetupLazy />} />,
		},
		AddNewStaff(store),
		EditStaff(store),
		TransferWorkLoad(store),
		StaffPrintPages(store),
	];
};
